import React from 'react'
import 'twin.macro'

const HiddenMessage = () => (
  <small tw="font-bold text-gray-500 text-sm italic mx-8 md:mx-0">(Verborgen bericht)</small>
)

export default HiddenMessage
